import { render, staticRenderFns } from "./exhibitorChoice.vue?vue&type=template&id=5a1bbd8e&scoped=true&"
import script from "./exhibitorChoice.vue?vue&type=script&lang=js&"
export * from "./exhibitorChoice.vue?vue&type=script&lang=js&"
import style0 from "./exhibitorChoice.vue?vue&type=style&index=0&id=5a1bbd8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1bbd8e",
  null
  
)

export default component.exports